import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0b2b44',
      light: '#154b6e',
      dark: '#071f30',
    },
    secondary: {
      main: '#e97c07',
      light: '#ff941f',
      dark: '#b55d00',
    },
    accent: {
      main: '#ffb45a',
      light: '#ffd5b5',
      dark: '#b95d00',
    },
    background: {
      default: '#f9fafc',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 800,
      fontSize: '3rem',
      '@media (max-width:600px)': {
        fontSize: '2.5rem',
      },
    },
    h2: {
      fontWeight: 700,
      fontSize: '2.3rem',
      '@media (max-width:600px)': {
        fontSize: '2rem',
      },
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.8rem',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 28,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 60,
          padding: '0.9rem 2.2rem',
          fontSize: '1.1rem',
          boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
        },
        containedPrimary: {
          background: '#e97c07',
          color: 'white',
          '&:hover': {
            background: '#ff941f',
          },
        },
        outlined: {
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 28,
          boxShadow: '0 10px 20px -5px rgba(0,0,0,0.1)',
        },
      },
    },
  },
});

export default theme;